import { JobOptionCreatableInterface } from '../interfaces/job-option-creatable.interface';
import { JobOptionDto } from './job-option.dto';
import { PickType } from '@nestjs/swagger';

export class JobOptionCreateDto
  extends PickType(JobOptionDto, ['jobId', 'optionId'])
  implements JobOptionCreatableInterface {}
